// extracted by mini-css-extract-plugin
export default {"customerRow":"KMrVXjaSSRn3IyLdVECZ","checked":"WuEye7cBCLzpkhTzsZSC","checkbox":"LI7elOdUliTQpzM5HkXg","infoBox":"RYXzdCVKvCtBwo1F59EK"};